<template lang="html">

  <article class="col-50 art-dest waypoints" data="fadeInUp">
    <a :href="data.enlace" target="_blank">
      <div class="img-destacado" :style="`background: url(${server+data.imagen}) center/cover no-repeat`"></div>
      <div class="text-dest">
        <div class="container-text">
          <h3 v-html="data.titulo"></h3>
          <p v-html="data.resumen"></p>
          <div class="flex row-reserve justify-between">
            <!-- Es la categoria del destacado, no un encabezado: iba detras del
                 h3 del titulo y rompia la secuencia de niveles. -->
            <p class="tag" v-html="data.tipo"></p>
            <a target="_blank" v-if="!!data.enlace" :href="data.enlace" class="mas-dark"></a>
          </div>
        </div>
      </div>
    </a>
  </article>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';


  export default  {
    name: 'destacado-el',
    props: ['data'],
    mounted() {
      $(".destacados .art-dest").hover(function() {
       $(this).find('p').slideDown();
     }, function() {
       $(this).find('p').slideUp();
     });
    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {
     ...mapGetters({
      lang: 'getLanguage',
      server : 'getServer'
    }),
   }
 }
</script>

<style scoped>
a:hover{
  opacity: 1;
}

.img-destacado{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/destacado-el.vue